//
//
//
//
//
//
//
//
//
//
//

import Base from '../../libs/base'

export default {
  mixins: [Base],
  props: {
    percent: {
      type: Number,
      default: 0
    },
    showCancel: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    cancel () {
      this.$emit('on-cancel')
    }
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/x-progress/index.vue